import React, { memo } from "react";
import { colors, frames, useMediaQuery } from "../../Styles";
import { SystemOverviewAreas } from "../../Styles/frames";

interface SystemOverviewLayout_Props {
  widgetComponents?: JSX.Element;
  cardDisplayComponent?: JSX.Element;
  attentionsComponent?: JSX.Element;
  systemControlsComponent?: JSX.Element;
}

const SystemOverviewLayout = memo(({ widgetComponents, cardDisplayComponent, attentionsComponent, systemControlsComponent }: SystemOverviewLayout_Props) => {
  const widgetBorders = useMediaQuery(`(min-width: 1289px)`);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: !widgetBorders ? "10px 1fr 10px" : "1fr", height: "100%", gridArea: "_page_inner_content"}}>
      { !widgetBorders && <div style={{ gridArea: "1/1/2/2", borderTop: "2px solid "+colors.greyDarkPrimary}}/> }
        <frames.SystemOverview style={{ gridArea: !widgetBorders ? "2/1/3/2" : undefined }}>
          <div style={{ gridArea: SystemOverviewAreas.numberDisplays }}>{cardDisplayComponent}</div>
          <div style={{ gridArea: SystemOverviewAreas.systemControls, display: "flex", alignItems: "end" }}>{systemControlsComponent}</div>
          <div style={{ gridArea: SystemOverviewAreas.attentions, height: !widgetBorders ? "580px" : undefined }}>{attentionsComponent}</div>
          <div style={{ gridArea: SystemOverviewAreas.widgets, display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: widgetBorders ? "10px 1fr 10px" : "1fr" }}>
            {widgetBorders && <div style={{ borderTop: "2px solid "+colors.greyDarkPrimary}}/> }
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
              padding: widgetBorders ? "0px 5px" : "0px",
              overflowX: "hidden",
              overflowY: widgetBorders ? "scroll" : "hidden",
              scrollbarColor: colors.greyDarkPrimary + colors.transparent,
              scrollbarWidth: "thin",
              height: widgetBorders ? "100%" : "fit-content"
            }}>
              {widgetComponents}
            </div>
            {widgetBorders && <div style={{ borderBottom: "2px solid "+colors.greyDarkPrimary}}/> }
          </div>
        </frames.SystemOverview>  
      { !widgetBorders && <div style={{ gridArea: "3/1/4/2", borderBottom: "2px solid "+colors.greyDarkPrimary}}/> }
    </div>
  )
})

export default SystemOverviewLayout